import { Button } from '@mui/material';

import { ReactComponent as EmptySVG } from '../../assets/img_emptyfile.svg';
import FormattedMessage from '../FormattedMessage';
import styles from './index.module.scss';

const NotFound = () => {
  return (
    <div className={styles.notFound}>
      <EmptySVG />
      <div className={styles.description}>
        <p dangerouslySetInnerHTML={{ __html: FormattedMessage('error.title') }} />
        <p dangerouslySetInnerHTML={{ __html: FormattedMessage('error.description') }} />
        <br />
        <p dangerouslySetInnerHTML={{ __html: FormattedMessage('system.required') }} />
        <div className={styles.btnContainer}>
          <Button onClick={() => window.location.reload()}>
            {FormattedMessage('error.refresh')}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default NotFound;
